import { render, staticRenderFns } from "./CardModalStatusChip.vue?vue&type=template&id=34843b0a&scoped=true&"
import script from "./CardModalStatusChip.vue?vue&type=script&lang=ts&"
export * from "./CardModalStatusChip.vue?vue&type=script&lang=ts&"
import style0 from "./CardModalStatusChip.vue?vue&type=style&index=0&id=34843b0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34843b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
